import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { FullPageLoader } from "@/components/Logo";

export function RequireVerified({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <FullPageLoader />;
  if (!user) return <Navigate to="/signin" replace state={{ from: location.pathname }} />;
  if (!user.email_verified) return <Navigate to="/check-email" replace />;
  return children;
}

export function RequireSignedIn({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullPageLoader />;
  if (!user) return <Navigate to="/signin" replace />;
  if (user.email_verified) return <Navigate to="/app" replace />;
  return children;
}

export function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullPageLoader />;
  if (user) return <Navigate to={user.email_verified ? "/app" : "/check-email"} replace />;
  return children;
}
